import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Feed from './feed';
import NotFound from '../not-found';
import AccessDenied from '../access-denied';
import VisaRequest from './request/visa-request';
import HotelRequest from './request/hotel-request';
import FlightRequest from './request/flight-request';
import RegistrationRequest from './request/registration-request';
import TransportationRequest from './request/transportation-request';
import StandaloneRequest from './request/standalone-request';

import VisaOffer from './offer/visa-offer';
import HotelOffer from './offer/hotel-offer';
import FlightOffer from './offer/flight-offer';
import RegistrationOffer from './offer/registration-offer';
import TransportationOffer from './offer/transportation-offer';
import StandaloneOffer from './offer/standalone-offer';

const Routes = () => (
    <>
        <Switch>
            <Route path="/offer/visa/:id(\d+)" exact component={VisaOffer} />
            <Route path="/offer/hotel/:id(\d+)" exact component={HotelOffer} />
            <Route path="/offer/flight/:id(\d+)" exact component={FlightOffer} />
            <Route path="/offer/registration/:id(\d+)" exact component={RegistrationOffer} />
            <Route path="/offer/transportation/:id(\d+)" exact component={TransportationOffer} />
            <Route path="/offer/standalone/:id(\d+)" exact component={StandaloneOffer} />
            <Route path="/request/:id(\d+)/visa" exact component={VisaRequest} />
            <Route path="/request/:id(\d+)/hotel" exact component={HotelRequest} />
            <Route path="/request/:id(\d+)/flight" exact component={FlightRequest} />
            <Route path="/request/:id(\d+)/registration" exact component={RegistrationRequest} />
            <Route path="/request/:id(\d+)/transportation" exact component={TransportationRequest} />
            <Route path="/request/:id(\d+)/standalone" exact component={StandaloneRequest} />
            <Route path="/home/access-denied" exact component={AccessDenied} />
            <Route path="/home" exact component={Feed} />
            <Route path="*" component={NotFound} />
        </Switch>
    </>
)

export default Routes;